import { TFunction } from 'i18next';
import { articleDescriptionMaxLength } from '@texas/resources/constants';
import { mandatoryWarning, withWarningTargets } from '../warnings';

interface CopyWarningContext {
  sourceCustomerId: number;
  hasSource: boolean;
  destinationCustomerId: number;
  branchCount: number;
  variantCount: number;
  itemCode: string;
  name: string;
  invalidLength: boolean;
  minimumLength: number;
  maximumLength: number;
  mode: 'single' | 'range';
  targetCount: number;
  validationFailed: boolean;
}

export function getCopyWarnings(
  context: CopyWarningContext,
  t: TFunction,
  scope: string,
) {
  const ready = context.hasSource;
  return withWarningTargets(
    {
      sourceCustomer: mandatoryWarning(
        !context.sourceCustomerId,
        t('article.copy.sourceCustomerRequired'),
      ),
      sourceArticle: mandatoryWarning(
        !!context.sourceCustomerId && !ready,
        t('article.copy.sourceArticleRequired'),
      ),
      destinationCustomer: mandatoryWarning(
        ready && !context.destinationCustomerId,
        t('article.create.customerRequired'),
      ),
      branches: mandatoryWarning(
        ready && !context.branchCount,
        t('article.create.branchesRequired'),
      ),
      variants: mandatoryWarning(
        ready && !context.variantCount,
        t('article.copy.variantRequired'),
      ),
      itemCode: mandatoryWarning(
        ready &&
          (!context.itemCode.trim() ||
            context.invalidLength ||
            context.validationFailed),
        !context.itemCode.trim()
          ? t('article.create.itemCodeRequired')
          : context.invalidLength
          ? t('article.copy.itemCodeLengthRequirement', {
              minimum: context.minimumLength,
              maximum: context.maximumLength,
            })
          : t('article.copy.validationFailed'),
      ),
      description: mandatoryWarning(
        ready &&
          (!context.name.trim() ||
            context.name.trim().length > articleDescriptionMaxLength),
        t('article.create.descriptionRequired', {
          maximum: articleDescriptionMaxLength,
        }),
      ),
      range: mandatoryWarning(
        ready &&
          context.mode === 'range' &&
          !!context.itemCode.trim() &&
          !context.targetCount,
        t('article.create.rangeLimit'),
      ),
    },
    scope,
  );
}
